var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 10,
    fill: "#F7DBB3",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9375 22.8438L34 14.0312L18.0625 22.8438L28.1875 28.4688C28.9375 27.7188 29.8125 27.125 30.8125 26.6875C31.8125 26.25 32.875 26.0312 34 26.0312C35.125 26.0312 36.1875 26.25 37.1875 26.6875C38.1875 27.125 39.0625 27.7188 39.8125 28.4688L49.9375 22.8438ZM29.9688 34C29.9688 32.875 30.3438 31.9375 31.0938 31.1875C31.9062 30.375 32.875 29.9688 34 29.9688C35.125 29.9688 36.0625 30.375 36.8125 31.1875C37.625 31.9375 38.0312 32.875 38.0312 34C38.0312 35.125 37.625 36.0938 36.8125 36.9062C36.0625 37.6562 35.125 38.0312 34 38.0312C32.875 38.0312 31.9062 37.6562 31.0938 36.9062C30.3438 36.0938 29.9688 35.125 29.9688 34ZM32.0312 52.8438L16 44.0312V26.3125L26.2188 31.9375C26.0938 32.5625 26.0312 33.25 26.0312 34C26.0312 35.875 26.5938 37.5312 27.7188 38.9688C28.8438 40.4062 30.2812 41.3438 32.0312 41.7812V52.8438ZM35.9688 52.8438V41.7812C37.7188 41.3438 39.1562 40.4062 40.2812 38.9688C41.4062 37.5312 41.9688 35.875 41.9688 34C41.9688 33.25 41.9062 32.5625 41.7812 31.9375L52 26.3125V44.0312L35.9688 52.8438Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyPageIcon);
export default __webpack_public_path__ + "static/media/buy-page-icon.9ad790fcfc7f6ea15cac2c5a3ce898d0.svg";
export { ForwardRef as ReactComponent };